/**
 * https://procentric.developer.lge.com/api-references/idcap-api/system#key-code-list
 * All keys except the following:
 * - POWER 0x0199 (because unable to boot TV if registered)
 * - DISC_POWER_OFF 0x02c1
 * - DISC_POWER_ON 0x02c2
 * - POWER_LOWBATTERY 0x02dd
 */
export const KEYS = {
  NUM_0: 0x0030,
  NUM_1: 0x0031,
  NUM_2: 0x0032,
  NUM_3: 0x0033,
  NUM_4: 0x0034,
  NUM_5: 0x0035,
  NUM_6: 0x0036,
  NUM_7: 0x0037,
  NUM_8: 0x0038,
  NUM_9: 0x0039,
  CH_UP: 0x01ab,
  CH_DOWN: 0x01ac,
  GUIDE: 0x01ca,
  INFO: 0x01c9,
  LEFT: 0x0025,
  UP: 0x0026,
  RIGHT: 0x0027,
  DOWN: 0x0028,
  ENTER: 0x000d,
  BACK: 0x01cd,
  EXIT: 0x03e9,
  RED: 0x0193,
  GREEN: 0x0194,
  YELLOW: 0x0195,
  BLUE: 0x0196,
  STOP: 0x019d,
  PLAY: 0x019f,
  PAUSE: 0x0013,
  REWIND: 0x019c,
  FAST_FORWARD: 0x01a1,
  LAST_CH: 0x02c7,
  PORTAL: 0x025a,
  ORDER: 0x026f,
  MINUS: 0x02c0,
  VOL_UP: 0x01bf,
  VOL_DOWN: 0x01c0,
  MUTE: 0x01c1,
  RECORD: 0x01a0,
  PAGE_UP: 0x0021,
  PAGE_DOWN: 0x0022,
  RF_BYPASS: 0x001d,
  NEXT_DAY: 0x01a9,
  PREV_DAY: 0x01a8,
  APPS: 0x005d,
  LINK: 0x025e,
  FORWARD: 0x00a7,
  ZOOM: 0x00fb,
  SETTINGS: 0x0263,
  NEXT_FAV_CH: 0x00b0,
  RES_1: 0x0070,
  RES_2: 0x0071,
  RES_3: 0x0072,
  RES_4: 0x0073,
  RES_5: 0x0074,
  RES_6: 0x0075,
  LOCK: 0x026b,
  SKIP: 0x026c,
  LIST: 0x03ee,
  LIVE: 0x026e,
  ON_DEMAND: 0x026f,
  PINP_MOVE: 0x0270,
  PINP_UP: 0x0271,
  PINP_DOWN: 0x0272,
  MENU: 0x0012,
  AD: 0x02bc,
  ALARM: 0x02bd,
  AV_MODE: 0x001f,
  SUBTITLE: 0x01cc,
  DVD: 0x02c3,
  EJECT: 0x019e,
  ENERGY_SAVING: 0x02c5,
  FAV: 0x02c6,
  FLASHBK: 0x02c7,
  INPUT: 0x02c8,
  MARK: 0x02c9,
  NETCAST: 0x03e8,
  PIP: 0x02cb,
  PIP_CH_DOWN: 0x02cc,
  PIP_CH_UP: 0x02cd,
  PIP_INPUT: 0x02ce,
  PIP_SWAP: 0x02cf,
  Q_MENU: 0x03ea,
  Q_VIEW: 0x03ef,
  RATIO: 0x03ed,
  SAP: 0x02d3,
  SIMPLINK: 0x02d4,
  STB: 0x02d5,
  T_OPT: 0x03ec,
  TEXT: 0x01cb,
  SLEEP_TIMER: 0x02d9,
  TV: 0x02da,
  TV_RAD: 0x02db,
  VCR: 0x02dc,
  SMART_HOME: 0x02de,
  SCREEN_REMOTE: 0x02df,
  POINTER: 0x02e0,
  LG_3D: 0x02e1,
  DATA: 0x02e2,
} as const

export type KeyName = keyof typeof KEYS
